import sanitiseOrderItem from '../../../Services/sanitiseOrderItem';

export default ({ orderGroupIndex, orderItemIndex }) => async (dispatch) => dispatch(sanitiseOrderItem({ orderGroupIndex, orderItemIndex }));